import { getClient } from '@/lib/restClient';
import { EatInSettings } from '@/pages/store-management/master-stores/components/Sidebar/MasterStoreSidebarForm/service';
import { StoreManagementDeliveryStoreService } from '@/services/StoreManagement/DeliveryStores/StoreManagementDeliveryStoreService';

export type StoreManagementDeliveryStoreUpdateParams = {
  external_store_id: string;
  delivery_service_id: number;
  cooking_time: number | null;
  external_auth_delivery_store: {
    id: number;
    email: string;
    password: string;
    username: string;
  };
  camel_order_prop: {
    takeout_start_days_offset: number | null;
    takeout_end_days_offset: number | null;
    eat_in_settings?: EatInSettings | null;
  } | null;
};

export type StoreManagementDeliveryStoreUpdateResponse = Record<string, never>;

export const useStoreManagementDeliveryStoreUpdate = async (
  id: string,
  params: StoreManagementDeliveryStoreUpdateParams
): Promise<StoreManagementDeliveryStoreUpdateResponse> => {
  const storeManagementDeliveryStoreService =
    new StoreManagementDeliveryStoreService(getClient());
  return await storeManagementDeliveryStoreService.update(id, params);
};
